import compose from 'lodash.flowright';
import { mapProps } from 'recompose';

import DigitalBundleConfigurationComplete from './DigitalBundleConfigurationComplete';
import withModal from '../../../../../../../../../components/global/modal/withModal';

export const DIGITAL_BUNDLE_CONFIGURATION_COMPLETE_MODAL =
  'MODAL/DIGITAL_BUNDLE_CONFIGURATION_COMPLETE';

export default withModal(
  compose(
    mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
      onClose: onRequestClose,
      ...actionProps,
      ...props,
    })),
  )(DigitalBundleConfigurationComplete),
  {
    name: DIGITAL_BUNDLE_CONFIGURATION_COMPLETE_MODAL,
    size: 'sm',
    type: 'full',
    hideHeader: true,
    dismissible: false,
    shouldCloseOnOverlayClick: false,
  },
);
